/* eslint-disable */
import React from 'react';
import { sessionInfo } from 'redux/actions';
import { useDispatch } from 'react-redux';
import { windowStore } from 'util/windowStore';
import { cacheKey, authTypes } from 'appConstants';
import { useLocation } from 'react-router-dom';
import { path } from 'routes/path';

export const useAuthenticateUser = (user, auth0ClientInitiated) => {
  const dispatch = useDispatch();
  const location = useLocation();

  /**
   * Check cache for JWT (used for legacy auth) and Auth0 Provider.
   */
  const token = windowStore.getToken();
  const cachedProviders = windowStore.get(cacheKey.PROVIDERS);
  const cachedAuth0Provider = (cachedProviders || []).find(
    (auth) => auth.authType === authTypes.AUTH0,
  );

  /**
   * Support for Angular-app as user may switch back and forth.
   * - Look for cached key starting with `@@auth0`
   * - if found, use its value to initialize auth0 client and authenticate user
   * This can be removed when the Angular (legacy) app is deprecated
   */
  const cachedAuth0ProviderAngualr = Object.keys(localStorage).find((item) =>
    item.includes(cacheKey.AUTH0_PREFIX),
  );

  /**
   * Change state to "is refreshing token" if any cached auth method is discovered.
   */
  const hasToken = Boolean(token || cachedAuth0Provider || cachedAuth0ProviderAngualr);
  const [isRefreshingToken, setIsRefreshingToken] = React.useState(hasToken);

  React.useEffect(() => {
    const authenticateUser = async () => {
      if (!user.authenticated && (token || auth0ClientInitiated)) {
        await dispatch(sessionInfo());
        setIsRefreshingToken(false);
      }
    };
    /**
     * authenticateUser() should not be executed on /iam path since
     * auth0 authentication is completed by Login component after
     * user redirects to /iam
     */
    if (location.pathname === path.IAM) {
      setIsRefreshingToken(false);
    } else {
      authenticateUser();
    }
  }, [dispatch, auth0ClientInitiated, user.authenticated, token, location.pathname]);

  return { isRefreshingToken };
};
